import { render, staticRenderFns } from "./Form-register.vue?vue&type=template&id=659b678c&"
import script from "./Form-register.vue?vue&type=script&lang=js&"
export * from "./Form-register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports